import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

class MessageConfig {
  action?: string = '';
  position?: MatSnackBarVerticalPosition = 'bottom';
  duration?: number | undefined = undefined;
}

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(private snackbar: MatSnackBar) {}

  open(message: string, cfg?: MessageConfig) {
    return this.snackbar.open(message, cfg?.action || 'OK', {
      duration: cfg?.duration !== undefined ? cfg.duration : 5000,
      verticalPosition: cfg?.position || 'top',
    });
  }

  warn(message: string, cfg?: MessageConfig) {
    return this.open(message, cfg);
  }

  error(message: string, cfg?: MessageConfig) {
    return this.open(message, cfg);
  }

  clear() {
    this.snackbar.dismiss();
  }
}
